import startsWith from 'lodash/startsWith';

import { ToolsSecondaryMenuItems } from '../../ToolsSecondaryMenu.types';

import { ArchiAppPath } from '../../../../../../archiApps/ArchiAppPath';
import { ArcheidosPath } from '../../../../../../archeidos/ArcheidosPath';
import { ModelViewerPath } from '../../../../../../modelViewers/ModelViewerPath';

import { ArchiAppsPermissions } from '../../../../../../archiApps/archiAppsConstants';
import { ModelViewerPermissions } from '../../../../../../modelViewers/modelViewerConstants';
import { ArcheidosPermissions } from '../../../../../../archeidos/archeidosConstants';

import {
  archiAppsKeys,
  archeidosKeys,
  modelViewersKeys
} from '../../../../../../../locales/keys';

export const toolsMenuLinks = [
  {
    name: ToolsSecondaryMenuItems.ARCHEIDOS,
    href: ArcheidosPath.index(),
    i18nText: archeidosKeys.archeidos,
    activeTest: (pathname: string) =>
      startsWith(pathname, ArcheidosPath.index()),
    permissions: [ArcheidosPermissions.READ_ARCHEIDOS_INDEX_PAGE]
  },
  {
    name: ToolsSecondaryMenuItems.MODEL_VIEWER,
    href: ModelViewerPath.index(),
    i18nText: modelViewersKeys.singular,
    activeTest: (pathname: string) =>
      startsWith(pathname, ModelViewerPath.index()),
    permissions: [ModelViewerPermissions.READ_MODEL_VIEWER_INDEX_PAGE]
  },
  {
    name: ToolsSecondaryMenuItems.ARCHI_APPS,
    href: ArchiAppPath.index(),
    i18nText: archiAppsKeys.plural,
    activeTest: (pathname: string) =>
      startsWith(pathname, ArchiAppPath.index()),
    permissions: [ArchiAppsPermissions.READ_ARCHI_APPS_INDEX_PAGE]
  }
];
